import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"
import { MANAGE_MANUAL_CL_V1_BREADCRUMBS } from "@/domains/thick-v1/breadcrumbs"
import { ManagePositionPageComposite } from "@/domains/thick-v1/components/manage-position"

const title = CL_PRODUCT_COPY.v1.collectFeesTitle

const ManualClCollectFeesPage = () => (
  <PageContainer>
    <MetaData title={title} />
    <PageTitle title={title} items={MANAGE_MANUAL_CL_V1_BREADCRUMBS} />
    <ManagePositionPageComposite activeTab="collect" />
  </PageContainer>
)

export default ManualClCollectFeesPage
